import { Outlet } from 'react-router-dom'
import { AppWrap } from '../AppWrap'
import { DrawerLogo } from '../DrawerLogo'
import s from './AppLayoutMinimal.module.scss'

export function AppLayoutMinimal() {
  return (
    <AppWrap>
      <div className={s.wrap}>
        <DrawerLogo href="/" className={s.logo} />
        <Outlet />
      </div>
    </AppWrap>
  )
}
